import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "io-mfe-ig-footer-auto-save" }
const _hoisted_3 = { class: "io-mfe-ig-footer-auto-save-types" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row q-gutter-sm" }

import { computed, ref} from 'vue';
import DropDown from 'components/global-common/DropDown.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { SUBMIT_OPTIONS } from 'components/grouper-common/common-constants';
import { isEmpty } from 'src/common/arrayUtil';
import CalculateAprBanner from 'components/grouper-common/CalculateAprBanner.vue';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperFooter',
  setup(__props) {

const grouperStore = useGrouperStore();
const  { submitDrgTypes, isPrimaryDrgMs } = storeToRefs(grouperStore);
const banner = ref(null);
const canSubmit = computed(() => !isEmpty(submitDrgTypes.value) && grouperStore.canSubmitDrg);

function saveDrg() {
  grouperStore.saveDrg();
}

function checkForBanner() {

  if (canSubmit.value) {
    banner.value?.toggle(false);
    return;
  }

  banner.value?.toggle(!!grouperStore.aprCalcNeededForSubmit);
}

function getSaveOrDraftMessage(): string {
  if (grouperStore.isDirty) {
    return ': Draft';
  } else if(!isEmpty(grouperStore.getLastSubmittedTypes)) {
    return ' Saved: ';
  }
}

function getSavedTypesDisplay(): string {
  if (grouperStore.isDirty) {
    return '';
  } else if(!isEmpty(grouperStore.getLastSubmittedTypes)) {
    return grouperStore.getLastSubmittedTypes.join(', ');
  }
}


return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card, { class: "iodine-footer" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_space),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_icon, {
              class: _normalizeClass(["io-mfe-ig-icon-small", {'io-mfe-ig-icon-success': !_unref(grouperStore).isDirty && !_unref(isEmpty)(_unref(grouperStore).getLastSubmittedTypes)}]),
              name: "fa-light fa-file-pen"
            }, null, 8, ["class"]),
            _createElementVNode("span", null, _toDisplayString(_unref(isPrimaryDrgMs) ? 'MS' : 'APR') + " DRG" + _toDisplayString(getSaveOrDraftMessage()), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(getSavedTypesDisplay()), 1)
          ]),
          _createVNode(_component_q_form, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(DropDown, {
                      modelValue: _unref(submitDrgTypes),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(submitDrgTypes) ? (submitDrgTypes).value = $event : null)),
                      options: _unref(SUBMIT_OPTIONS),
                      "option-label": "label",
                      "option-value": "value",
                      label: "Save As",
                      "iodine-class-name": "drg-save-as",
                      multiple: "",
                      "check-boxes": "",
                      "disabled-option-tooltip": "Please calculate a DRG first",
                      "disable-all-options": !_unref(grouperStore).canSubmitDrg,
                      disable: !_unref(grouperStore).canSubmitDrg,
                      "popup-content-class": "io-mfe-ig-submit-dropdown"
                    }, null, 8, ["modelValue", "options", "disable-all-options", "disable"]),
                    (!_unref(grouperStore).canSubmitDrg)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Please calculate a DRG first ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      onClick: saveDrg,
                      onMouseover: checkForBanner,
                      unelevated: "",
                      class: _normalizeClass(["iodine-submit-button", { 'io-mfe-ig-submit-disabled': !canSubmit.value }]),
                      disable: !canSubmit.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Submit ")
                      ]),
                      _: 1
                    }, 8, ["class", "disable"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(CalculateAprBanner, {
      ref_key: "banner",
      ref: banner
    }, null, 512)
  ], 64))
}
}

})